import {tableC1a, tableC1b, tableC2, tableC3, tableC4, tableC5, tableC6} from "./formulaCtables";
import {
    HAS_DEPENDENTS_NO,
    HAS_DEPENDENTS_YES,
    STUDENT_MARITAL_STATUS_MARRIED,
    STUDENT_MARITAL_STATUS_SINGLE
} from "../constants/MAGIC_NUMBERS";
import {DEBUG_MODE} from "../constants/DEBUG_MODE";
import {faeDebugger} from "../../../faeDebugger";

export const FormulaC = (formData) => {

    let debugObject = [];

    //  Student (and Spouse) Income Additions
    let line1 = () => {
        //  Student (and Spouse) AGI
        let lineA = () => {
            return parseInt(formData.step3.studentAdjustedGrossIncome);
        };

        //  Student (and Spouse) Deductible Payments toIRA/KEOGH/Other
        let lineB = () => {
            return 0;
        };

        //  Student (and Spouse) Tax-Exempt Interest Income
        let lineC = () => {
            return 0;
        };

        //  Student (and Spouse) Untaxed Portions of IRA Distributions
        //  (Excluding rollovers; if less than zero, enter zero)
        let lineD = () => {
            return 0;
        };

        //  Student (and Spouse) Untaxed Portions of Pensions
        //  (Excluding rollovers; if less than zero, enter zero)
        let lineE = () => {
            return 0;
        };

        //  Student (and Spouse) Foreign Income Exclusion
        //  (reported on U.S. Tax Return; if less than zero, enter the absolute value)
        let lineF = () => {
            return 0;
        };

        //  Total Student (and Spouse) Income Additions
        //  (sum of lines a, b, c, d,e, and f)
        //  formData.step3.studentOtherIncome stands in for the sum of lines b, c, d, e, f
        let line1 = () => {
            let sum = lineA() + lineB() + lineC() + lineD() + lineE() + lineF() +
                parseInt(formData.step3.studentOtherIncome);

            debugObject['line 1'] = {
                'a': lineA(),
                'b': lineB(),
                'c': lineC(),
                'd': lineD(),
                'e': lineE(),
                'f': lineF(),
                'other': parseInt(formData.step3.studentOtherIncome),
                'SUM': sum
            };

            return sum;
        };

        return line1();
    };

    //  Student (and Spouse) Income Offsets
    let studentIncomeOffsets = () => {

        //  Total Student (and Spouse) Income Offsets (sum of lines g, h, and i)
        let line2 = () => {
            //  Student (and Spouse) College Grant and Scholarship Aid
            let lineG = () => {
                return 0;
            };

            //  Student (and Spouse) Education Credits
            let lineH = () => {
                return 0;
            };

            //  Student (and Spouse) Federal Work-study (FWS)
            let lineI = () => {
                return 0;
            };

            let sum = lineG() + lineH() + lineI();

            debugObject['line 2'] = {
                'g': lineG(),
                'h': lineH(),
                'i': lineI(),
                'SUM': sum
            };

            return sum;
        };

        //  Total Student (and Spouse) Income (line 1 minus line 2)
        //  May be a negative number
        let line3 = () => {
            let total = line1() - line2();
            debugObject['line 3'] = total;
            return total;
        };

        return line3();
    };

    //  Allowances Against Student (and Spouse) Income
    let allowancesAgainstStudentIncome = () => {
        //  Student (and Spouse) U.S. Income Tax Paid (or Foreign Equivalent)
        let line4 = () => {
            let value = parseInt(formData.step3.studentTaxesPaid);
            debugObject['line 4'] = value;
            return value;
        };

        //  Payroll Tax Allowance (Table B1)
        let line5 = () => {
            //  Medicare’s Hospital Insurance (HI) Program Tax Rate(Table B1: Step 1)
            let line5a = () => {
                return tableC1a(formData);
            };

            //  Old-age, survivors, & disability insurance (OASDI) Tax Rate(Table B1: Step 2)
            let line5b = () => {
                return tableC1b(formData);
            };

            let value = {
                'a': line5a(),
                'b': line5b()
            };

            debugObject['line 5'] = value;
            return value;
        };

        //  Income Protection Allowance (IPA)
        //  See Table C2 if the student indicator is married with dependents
        //      Table C3 if the student indicator is unmarried with dependents
        let line6 = () => {
            let value = (formData.step3.studentHasDependents === HAS_DEPENDENTS_YES)
                ? (formData.step3.studentMaritalStatus === STUDENT_MARITAL_STATUS_MARRIED)
                    ? tableC2(formData)
                    : tableC3(formData)
                : 0;

            debugObject['line 6'] = value;
            return value;
        };

        //  Employment Expense Allowance (EEA)
        //  If the student indicator is unmarried, the lesser of:
        //      35% of the student earned income, OR
        //      $4,730
        //  If the student indicator is married, the lesser of:
        //      35% of the student and student’s spouse combined earned income, OR
        //      $4,730
        let line7 = () => {
            const defaultValue = 4730;
            const multiplier = 0.35;
            let income = parseInt(formData.step3.studentAdjustedGrossIncome)
                + parseInt(formData.step3.studentOtherIncome);
            let possible = Math.round(income * multiplier);

            let value = Math.min(possible, defaultValue);

            debugObject['line 7'] = value;
            return value;
        };

        //  Total Student (and Spouse) Allowances Against Income (sum lines 4,5a, 5b, 6, and 7)
        let line8 = () => {
            let value5 = line5();
            let total = line4() + value5['a'] + value5['b'] + line6() + line7();

            debugObject['line 8'] = total;
            return total;
        };

        return Math.round(line8());
    };

    //  Student's Available Income (StAI)
    let studentsAvailableIncome = () => {
        let line9 = () => {
            //  Total Student (and Spouse) Income (line 3)
            //  See function studentIncomeOffsets() to see that it returns line 3
            let line3 = studentIncomeOffsets();

            //  Total Student (and Spouse) Allowances Against Income (line 8)
            let line8 = allowancesAgainstStudentIncome();

            let value = line3 - line8;
            debugObject['line 9'] = value;
            return value;
        };

        return line9();
    };

    let studentContributionFromAssets = () => {
        //  Annual child support received for the last complete calendar year
        let line10 = () => {
            let value = 0;
            debugObject['line 10'] = value;
            return value;
        };

        //  Cash, savings, and checking accounts
        let line11 = () => {
            let value = parseInt(formData.step3.studentAssets);
            debugObject['line 11'] = value;
            return value;
        };

        //  Net worth of investments
        //      Includes: time deposits, money market funds, real estate
        //          (excluding primary residence), vacation homes, income producing
        //          property, trusts, stocks, bonds, derivatives, securities,
        //          mutual funds, tax shelters, and qualified education benefits
        //      If negative, enter zero
        let line12 = () => {
            let value = 0;
            debugObject['line 12'] = value;
            return value;
        };

        //  Adjusted net worth of business and/or farm (Table C4)
        //  Net worth of business and/or farm multiplied by the applicable
        //  adjustment in Table C4
        let line13 = () => {
            let derivedValue = 0;
            let value = tableC4(derivedValue);
            debugObject['line 13'] = value;
            return value;
        };

        // Net worth (sum of lines 10, 11, 12, and 13)
        let line14 = () => {
            let netWorth = line10() + line11() + line12() + line13();
            debugObject['line 14'] = netWorth;
            return netWorth;
        };

        //  Asset Protection Allowance (APA; Table C5)
        let line15 = () => {
            let value = tableC5(formData);
            debugObject['line15'] = value;
            return value;
        };

        //  Discretionary Net Worth - Line 14 minus line 15
        let line16 = () => {
            let value = line14() - line15();
            debugObject['line 16'] = value;
            return value;
        };

        //  Asset Conversion Rate (7%)
        let line17 = () => {
            let value = 0.07;
            debugObject['line 17'] = value;
            return value;
        };

        let line18 = () => {
            let sca = line16() * line17();
            let value = sca < 0
                ? 0
                : Math.round(sca);
            debugObject['line 18'] = value;
            return value;
        };

        return line18();
    };

    let SAI = () => {

        //  Student Adjusted Available Income (AAI; sum of lines 9 and 18)
        //      May be a negative number
        let line19 = () => {
            let value = studentsAvailableIncome() + studentContributionFromAssets();

            debugObject['line 19'] = value;
            return value;
        }

        let line20 = () => {
            let value = tableC6(line19());
            debugObject['line 20'] = value;
            return value;
        }

        let sai = () => {
            let value = line20();

            if(value < -1500) {
                value = -1500;
            }

            debugObject['SAI'] = value;
            return value;
        }

        return sai();
    };

    let value = SAI();

    if(DEBUG_MODE === true) {

        let debugBlock = new faeDebugger('Formula C - Independent Students with Dependent(s) Other than a Spouse');

        let blockInputs = new faeDebugger('Inputs');

        let blockStudentContributionFromIncome = new faeDebugger('Student Contribution from Income');
        let blockStudentAndSpouseIncomeAdditions = new faeDebugger('Student (and Spouse) Income Additions');
        let blockStudentAndSpouseIncomeOffsets = new faeDebugger('Student (and Spouse) Income Offsets');
        let blockAllowancesAgainstStudentAndSpouseIncome = new faeDebugger('Allowances Against Student (and Spouse) Income');
        let blockStudentsAvailableIncomeStAI = new faeDebugger('Student’s Available Income (StAI)');

        let blockStudentContributionFromAssets = new faeDebugger('Student Contribution from Assets');
        let blockStudentAidIndex = new faeDebugger('Student Aid Index');

        debugBlock.addBlock('00', blockInputs);
        blockInputs.addLine('Student Marital Status', `calculated: ${parseInt(formData.step3.studentMaritalStatus)} - radio input: "${formData.step3.studentMaritalStatus}"`);
        blockInputs.addLine('Student has dependents', `calculated: ${parseInt(formData.step3.studentHasDependents)} - radio input: "${formData.step3.studentHasDependents}"`);
        blockInputs.addLine('Family Size', `calculated: ${parseInt(formData.step3.familySize)} - text input: "${formData.step3.familySize}"`);
        blockInputs.addLine('Student Adjusted Gross Income', `calculated: ${parseInt(formData.step3.studentAdjustedGrossIncome)} - text input: "${formData.step3.studentAdjustedGrossIncome}"`);
        blockInputs.addLine('Student Other Income', `calculated: ${parseInt(formData.step3.studentOtherIncome)} - text input: "${formData.step3.studentOtherIncome}"`);
        blockInputs.addLine('Student Taxes Paid', `calculated: ${parseInt(formData.step3.studentTaxesPaid)} - text input: "${formData.step3.studentTaxesPaid}"`);
        blockInputs.addLine('Student Assets', `calculated: ${parseInt(formData.step3.studentAssets)} - text input: "${formData.step3.studentAssets}"`);

        debugBlock.addBlock('01', blockStudentContributionFromIncome);
        blockStudentContributionFromIncome.addBlock('01', blockStudentAndSpouseIncomeAdditions);
        blockStudentAndSpouseIncomeAdditions.addLine('a', debugObject['line 1']['a']);
        blockStudentAndSpouseIncomeAdditions.addLine('b', debugObject['line 1']['b']);
        blockStudentAndSpouseIncomeAdditions.addLine('c', debugObject['line 1']['c']);
        blockStudentAndSpouseIncomeAdditions.addLine('d', debugObject['line 1']['d']);
        blockStudentAndSpouseIncomeAdditions.addLine('e', debugObject['line 1']['e']);
        blockStudentAndSpouseIncomeAdditions.addLine('f', debugObject['line 1']['f']);
        blockStudentAndSpouseIncomeAdditions.addLine('other', debugObject['line 1']['other']);
        blockStudentAndSpouseIncomeAdditions.addLine('1', debugObject['line 1']['SUM']);

        blockStudentContributionFromIncome.addBlock('02', blockStudentAndSpouseIncomeOffsets);
        blockStudentAndSpouseIncomeOffsets.addLine('g', debugObject['line 2']['g']);
        blockStudentAndSpouseIncomeOffsets.addLine('h', debugObject['line 2']['h']);
        blockStudentAndSpouseIncomeOffsets.addLine('i', debugObject['line 2']['i']);
        blockStudentAndSpouseIncomeOffsets.addLine('2', debugObject['line 2']['SUM']);
        blockStudentAndSpouseIncomeOffsets.addLine('3', debugObject['line 3']);

        blockStudentContributionFromIncome.addBlock('03', blockAllowancesAgainstStudentAndSpouseIncome);
        blockAllowancesAgainstStudentAndSpouseIncome.addLine('4', debugObject['line 4']);
        blockAllowancesAgainstStudentAndSpouseIncome.addLine('5a', debugObject['line 5']['a']);
        blockAllowancesAgainstStudentAndSpouseIncome.addLine('5b', debugObject['line 5']['b']);
        blockAllowancesAgainstStudentAndSpouseIncome.addLine('6', debugObject['line 6']);
        blockAllowancesAgainstStudentAndSpouseIncome.addLine('7', debugObject['line 7']);
        blockAllowancesAgainstStudentAndSpouseIncome.addLine('8', debugObject['line 8']);

        blockStudentContributionFromIncome.addBlock('04', blockStudentsAvailableIncomeStAI);
        blockStudentsAvailableIncomeStAI.addLine(' ', debugObject['line 3']);
        blockStudentsAvailableIncomeStAI.addLine(' ', debugObject['line 8']);
        blockStudentsAvailableIncomeStAI.addLine('9', debugObject['line 9']);

        debugBlock.addBlock('02', blockStudentContributionFromAssets);
        blockStudentContributionFromAssets.addLine('10', debugObject['line 10']);
        blockStudentContributionFromAssets.addLine('11', debugObject['line 11']);
        blockStudentContributionFromAssets.addLine('12', debugObject['line 12']);
        blockStudentContributionFromAssets.addLine('13', debugObject['line 13']);
        blockStudentContributionFromAssets.addLine('14', debugObject['line 14']);
        blockStudentContributionFromAssets.addLine('15', debugObject['line 15']);
        blockStudentContributionFromAssets.addLine('16', debugObject['line 16']);
        blockStudentContributionFromAssets.addLine('17', debugObject['line 17']);
        blockStudentContributionFromAssets.addLine('18', debugObject['line 18']);

        debugBlock.addBlock('03', blockStudentAidIndex);
        blockStudentAidIndex.addLine(' ', debugObject['line 9']);
        blockStudentAidIndex.addLine('19', debugObject['line 19']);
        blockStudentAidIndex.addLine('20', debugObject['line 20']);
        blockStudentAidIndex.addLine('21', debugObject['SAI']);

        debugBlock.toGroup();
    }

    return value;
}
